interface ProcessStepProps {
  stepNumber: string;
  title: string;
  description: string;
}

export default function ProcessStep({ stepNumber, title, description }: ProcessStepProps) {
  return (
    <div className="flex flex-col items-start flex-1 h-full">
      <div className="flex px-3 py-2 justify-center items-center gap-2 self-stretch border-l border-primary">
        <div className="flex-1 text-black font-medium text-sm md:text-base leading-[150%] font-urbanist">
          {stepNumber}
        </div>
      </div>
      <div 
        className="flex p-4 md:p-5 lg:p-6 flex-col items-start gap-2 self-stretch border border-gray-200 bg-white shadow-lg h-full"
        style={{
          background: 'linear-gradient(121deg, color-mix(in srgb, var(--color-primary) 15%, transparent) 4.01%, transparent 13.65%), white'
        }}
      >
        <h3 className="self-stretch text-black font-semibold text-base md:text-lg leading-[150%] font-urbanist">
          {title}
        </h3>
        <p className="self-stretch text-[#666666] font-medium text-xs md:text-sm leading-[150%] font-urbanist">
          {description}
        </p>
      </div>
    </div>
  );
}


